<template>
  <div class="sportello">

    <el-tabs v-model="tabActive" type="card" class="col-24" v-loading="loading_statociv" @tab-click="handleClick">
      <!-- VARIAZIONE ANAGRAFICHE START -->
      <el-tab-pane v-loading="loading_varanag">


        <div style="width: 250px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('sportello.varAnag').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <div v-if="datiPersVar.inAttesa === '1'" class="tab-sportello row row-custom inAttesa">
          <div class="col-24">
            <span>{{ datiPersVar.inAttesaMsg }}</span>
          </div>
        </div>

        <div class="tab-sportello row row-custom">
          <div class="colonna col-24">
            <div class="row">
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom padding">
                  <div class="my-area col-24 no-padding">
                    {{ $t('sportello.datiPers').toUpperCase() }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.btn.modifica') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-switch v-model="switchModifica" active-color="#007c74" inactive-color="#cecece"
                      :disabled="datiPersVar.inAttesa === '1'">
                    </el-switch>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.statoCiv') }} (*)
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-select v-model="datiPersVar.codStatoCiv" :disabled="!switchModifica">
                      <el-option v-for="item in tbl_statoCiv" :key="item.codice" :label="item.statoCiv"
                        :value="item.codice">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.cfiscCon') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.codFiscCon" clearable :disabled="!switchModifica"
                      autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.tel1') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.pref1" clearable :disabled="!switchModifica"
                      autocomplete="off" style="width: 20%; float: left"></el-input>
                    <el-input placeholder="" v-model="datiPersVar.tel1" clearable :disabled="!switchModifica"
                      autocomplete="off" style="width: 78%; float: right"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.tel2') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.pref2" clearable :disabled="!switchModifica"
                      autocomplete="off" style="width: 20%; float: left"></el-input>
                    <el-input placeholder="" v-model="datiPersVar.tel2" clearable :disabled="!switchModifica"
                      autocomplete="off" style="width: 78%; float: right"></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-sportello row row-custom">
          <div class="colonna col-24">

            <div class="row">
              <!-- RESIDENZA -->
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom padding">
                  <div class="my-area col-24 no-padding">
                    {{ $t('sportello.res').toUpperCase() }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.comune') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-select class="custom-select-el" v-model="datiPersVar.resDesCom" :disabled="!switchModifica"
                      placeholder="" :filterable="true" :remote="true" :reserve-keyword="true"
                      :remote-method="searchComuni" value-key="codice" @change="((value) => changeComune(value, 'res'))">
                      <el-option v-for="option in tbl_comuni" :label="option.comune" :key="option.codice"
                        :value="option">
                        {{ (option.comune) }}
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.ind') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.resIn" clearable :disabled="!switchModifica"
                      autocomplete="off" style="width: 80%; float: left"></el-input>
                    <el-input placeholder="" v-model="datiPersVar.resNum" clearable :disabled="!switchModifica"
                      autocomplete="off" style="width: 18%; float: right"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.pr') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.resDesProv" clearable disabled
                      autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.reg') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.resDesReg" clearable disabled
                      autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.cap') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.resCap" clearable :disabled="!switchModifica"
                      autocomplete="off"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.dataCambio') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-date-picker class="dt-picker" v-model="datiPersVar.dataCambioRes" :disabled="!switchModifica"
                      type="date" format="dd/MM/yyyy" value-format="yyyyMMdd" placeholder="">
                    </el-date-picker>
                  </div>
                </div>
              </div>

              <!-- DOMICILIO -->
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom padding">
                  <div class="my-area col-24 no-padding">
                    {{ $t('sportello.dom').toUpperCase() }}
                    <icon v-if="switchModifica" name="riv-copy" scale="1.2" @click.native="copiaResidenza()"></icon>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.comune') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">

                    <el-select class="custom-select-el" v-model="datiPersVar.domDesCom" :disabled="!switchModifica"
                      placeholder="" :filterable="true" :remote="true" :reserve-keyword="true"
                      :remote-method="searchComuni" value-key="codice" @change="((value) => changeComune(value, 'dom'))">
                      <el-option v-for="option in tbl_comuni" :label="option.comune" :key="option.codice"
                        :value="option">
                        {{ (option.comune) }}
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.ind') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.domIn" clearable :disabled="!switchModifica"
                      autocomplete="off" style="width: 80%; float: left"></el-input>
                    <el-input placeholder="" v-model="datiPersVar.domNum" clearable :disabled="!switchModifica"
                      autocomplete="off" style="width: 18%; float: right"></el-input>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.pr') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.domDesProv" clearable disabled
                      autocomplete="off"></el-input>
                  </div>
                </div>
                <!--<div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.reg') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.domDesReg" clearable
                              disabled autocomplete="off"></el-input>
                  </div>
                </div>-->
                <div class="elemento row row-custom">
                  <div class="sportello-label col-md-11 col-12">
                    {{ $t('sportello.cap') }}
                  </div>
                  <div class="sportello-value col-md-13 col-12">
                    <el-input placeholder="" v-model="datiPersVar.domCap" clearable :disabled="!switchModifica"
                      autocomplete="off"></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="action">
          <el-button class="WEB-button WEB-button-primary" v-if="switchModifica" @click="confirmVarAnag()">
            {{ $t('sportello.btn.salva') }}
          </el-button>
        </div>


      </el-tab-pane>
      <!-- VARIAZIONE ANAGRAFICHE END -->

      <!-- DATI PERSONALI START -->
      <el-tab-pane v-loading="loading_tfr || loading_fide || loading_prevint || loading_assfam || loading_detfis">
        <div style="width: 250px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('sportello.datiPers').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <el-collapse v-model="accordionActive" accordion>
          <el-collapse-item :title="$t('sportello.accordion1.titolo')" name="1">

            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.accordion1.titolo1').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-md-11 col-12 no-padding">

                      </div>
                      <div class="my-area-panel col-md-6 col-6">
                        {{ $t('sportello.accordion1.inps').toUpperCase() }}
                      </div>
                      <div class="my-area-panel col-md-7 col-6">
                        {{ $t('sportello.accordion1.azienda').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion1.ant') }}
                      </div>
                      <div class="sportello-value col-md-6 col-6">
                        {{ tfr.antIn }}
                      </div>
                      <div class="sportello-value col-md-7 col-6">
                        {{ tfr.antAz }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion1.res') }}
                      </div>
                      <div class="sportello-value col-md-6 col-6">
                        {{ tfr.resIn }}
                      </div>
                      <div class="sportello-value col-md-7 col-6">
                        {{ tfr.resAz }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ $t('sportello.accordion1.titolo2').toUpperCase() }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion1.versFondo') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ tfr.versFondo }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </el-collapse-item>
          <el-collapse-item :title="$t('sportello.accordion2.titolo')" name="2">

            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div class="row">

                  <div class="blocco col-24 col-xl-12 no-padding">

                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-md-11 col-12 no-padding" style="text-align: right">
                        {{ $t('sportello.accordion2.benef').toUpperCase() }}
                      </div>
                      <div class="my-area-panel col-md-13 col-12">
                      </div>
                    </div>
                    <div v-for="(fid, index) in fide" :key="index" class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ fid.beneficiario }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </el-collapse-item>
          <el-collapse-item :title="$t('sportello.accordion3.titolo')" name="3">

            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.fondo') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ prevint.fondo }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.id') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ prevint.id }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.inizioCont') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ getDate('AAAAMM', prevint.inizioCont) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.inizioTfr') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ getDate('AAAAMM', prevint.inizioTfr) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.contDit') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ prevint.contDit }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.contAggDit') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ prevint.contAggDit }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.contDip') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ prevint.contDip }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.contAggDip') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ prevint.contAggDip }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.contDipF') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ prevint.contDipF }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion3.contTfr') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ prevint.contTfr }}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </el-collapse-item>

          <el-collapse-item :title="$t('sportello.accordion4.titolo')" name="4">


            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion4.af') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ assfam.AF }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion4.numComp') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ assfam.numComp }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion4.reddito') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ assfam.reddito }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion4.importo') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ assfam.importo }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion4.scadGen') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ getDate('AAAAMM', assfam.scadGen) }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion4.scadStat') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ getDate('AAAAMM', assfam.scadStat) }}
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item :title="$t('sportello.accordion5.titolo')" name="5">

            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion5.stato') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ detfis.stato }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion5.reddito') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ detfis.reddito }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion5.detLavDip') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ detfis.detLavDip }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion5.detCon') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ detfis.detCon }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion5.dataDetCon') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ detfis.dataDetCon }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion5.irpef') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ detfis.irpef }}
                      </div>
                    </div>
                    <div v-for="(fam, index) in detfis_list" :key="index" style="margin-top: 20px">

                      <div class="elemento row row-custom padding">
                        <div class="my-area-panel col-24 no-padding">
                          {{ fam.parentela }}
                        </div>
                      </div>
                      <div class="elemento row row-custom">
                        <div class="sportello-label col-md-11 col-12">
                          {{ $t('sportello.accordion5.cfisc') }}
                        </div>
                        <div class="sportello-value col-md-13 col-12">
                          {{ fam.codFisc }}
                        </div>
                      </div>
                      <div class="elemento row row-custom" v-show="fam.nascita !== '00000000'">
                        <div class="sportello-label col-md-11 col-12">
                          {{ $t('sportello.accordion5.nascita') }}
                        </div>
                        <div class="sportello-value col-md-13 col-12">
                          {{ getDate('AAAAMMGG', fam.nascita) }}
                        </div>
                      </div>
                      <div class="elemento row row-custom">
                        <div class="sportello-label col-md-11 col-12">
                          {{ $t('sportello.accordion5.periodo') }}
                        </div>
                        <div class="sportello-value col-md-13 col-12">
                          {{ getDate('AAAAMM', fam.valInizio) }} - {{ getDate('AAAAMM', fam.valFine) }}
                        </div>
                      </div>
                      <div class="elemento row row-custom">
                        <div class="sportello-label col-md-11 col-12">
                          {{ $t('sportello.accordion5.percent') }}
                        </div>
                        <div class="sportello-value col-md-13 col-12">
                          {{ fam.carico }}
                        </div>
                      </div>
                      <div class="elemento row row-custom">
                        <div class="sportello-label col-md-11 col-12">
                          {{ $t('sportello.accordion5.titolare') }}
                        </div>
                        <div class="sportello-value col-md-13 col-12">
                          {{ fam.handicap }}
                        </div>
                      </div>

                    </div>



                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item :title="$t('sportello.accordion6.titolo')" name="6">

            <div class="tab-sportello row row-custom">
              <div class="colonna col-24">
                <div v-for="(congedo, index) in congedi" :key="index" class="row">
                  <div class="blocco col-24 col-xl-12 no-padding">
                    <div class="elemento row row-custom padding">
                      <div class="my-area-panel col-24 no-padding">
                        {{ congedo.cognx }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion6.tipoPar') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ congedo.tipoPar }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion6.nascita') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ congedo.nascita | formattaData('GGMMAAAA') }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion6.periodo') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ congedo.valInizio | formattaData('GGMMAAAA') }} - {{ congedo.valFine |
                        formattaData('GGMMAAAA') }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion6.tipoCong') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ congedo.tipoCong }}
                      </div>
                    </div>
                    <div class="elemento row row-custom">
                      <div class="sportello-label col-md-11 col-12">
                        {{ $t('sportello.accordion6.mod') }}
                      </div>
                      <div class="sportello-value col-md-13 col-12">
                        {{ congedo.modalita }}
                      </div>
                    </div>


                  </div>
                </div>
              </div>

            </div>
          </el-collapse-item>

        </el-collapse>

      </el-tab-pane>
      <!-- DATI PERSONALI END -->

      <!-- RICHIESTA MDULISTICA START -->
      <el-tab-pane v-loading="loading_moduli">
        <div style="width: 250px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('sportello.ricMod').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <div class="tab-sportello row row-custom">
          <div class="colonna col-24">
            <div class="row">
              <div class="blocco col-24 col-xl-12 no-padding">
                <div class="elemento row row-custom padding">
                  <div class="my-area-panel col-md-11 col-12 no-padding">
                    {{ $t('sportello.moduli').toUpperCase() }}
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="my-radio">
                    <el-radio-group v-model="modulo">
                      <el-radio v-for="item in moduli" :label="item.tipo" :key="item.tipo">{{ item.descrizione }}
                      </el-radio>

                    </el-radio-group>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="action">
          <el-button class="WEB-button WEB-button-primary" @click="ricModulo()">
            {{ $t('sportello.btn.salva') }}
          </el-button>
        </div>


        <!--<auto v-if="tabActive === '3'" :trasferta="trasferta" :tbl_genSta="tbl_genSta"></auto>-->
      </el-tab-pane>
      <!-- RICHIESTA MDULISTICA END -->
    </el-tabs>

  </div>
</template>
<script>
export default {
  name: 'SportelloIT',
  i18n: {
    messages: {
      it_IT: {
        sportello: {
          varAnag: 'Variazione Anagrafica',
          ricMod: 'Richiesta Modulistica',
          moduli: 'Elenco Moduli',
          datiPers: 'Dati Personali',
          statoCiv: 'Stato Civile',
          cfiscCon: 'Codice Fiscale Coniuge',
          tel1: 'Telefono 1',
          tel2: 'Telefono 2',
          res: 'Residenza',
          dom: 'Domicilio',
          comune: 'Comune',
          ind: 'Indirizzo/N° Civico',
          pr: 'Provincia',
          reg: 'Regione',
          cap: 'CAP',
          dataCambio: 'Data Cambio Residenza',
          accordion1: {
            titolo: 'TFR',
            titolo1: 'TFR presso azienda/INPS',
            titolo2: 'TFR a fondo',
            ant: 'Anticipazioni già percepite',
            res: 'Residuo al 31/12/a.p.',
            inps: 'INPS',
            azienda: 'Azienda',
            versFondo: 'Versamenti effettuati al 31/12/a.p.',
            imp: 'Importo'
          },
          accordion2: {
            titolo: 'Fideiussione attivata',
            benef: 'Beneficiario'
          },
          accordion3: {
            titolo: 'Dati di adesione alla Previdenza integrativa',
            fondo: 'Fondo (attuale)',
            id: 'Identificatore dipendente c/o fondo',
            inizioCont: 'Data inizio versamento contributi',
            inizioTfr: 'Data inizio versamento TFR',
            contDit: 'Contributo ditta (%)',
            contAggDit: 'Contributo aggiuntivo ditta',
            contDip: 'Contributo dipendente (%)',
            contAggDip: 'Contributo aggiuntivo dipendente',
            contDipF: 'Contributo fisso dipendente (Euro)',
            contTfr: 'Contributo TFR (%)'
          },
          accordion4: {
            titolo: 'Dati degli assegni familiari',
            af: 'Codice tabella AF',
            numComp: 'N. componenti nucleo familiare',
            reddito: 'Reddito comunicato',
            importo: 'Importo mensile percepito',
            scadGen: 'Scadenza generale',
            scadStat: 'Data scadenza stato di famiglia',
          },
          accordion5: {
            titolo: 'Dati per detrazioni fiscali',
            stato: 'Stato civile',
            reddito: 'Reddito riferimento calcolo',
            detLavDip: 'Detrazione lavoro dipendente',
            detCon: 'Detrazione coniuge',
            dataDetCon: 'Data decorrenza detr. coniuge',
            irpef: 'Aliquota IRPEF scelta dal dipendente',
            periodo: 'Periodo inizio e fine validità',
            percent: '% a carico',
            titolare: 'Titolare di handicap',
            cfisc: 'Codice Fiscale',
            nascita: 'Data di Nascita'
          },
          accordion6: {
            titolo: 'Congedi parentali',
            tipoPar: 'Tipo parentela',
            nascita: 'Data di Nascita',
            periodo: 'Periodo inizio e fine validità',
            tipoCong: 'Tipo Congedo',
            mod: 'Modalità'
          },
          msg: {
            copiaTitle: 'Copia i Dati di Residenza',
            copia: 'Sei sicuro di voler copiare i dati di Residenza?',
            1: 'Dato en elaboracion de la ificina del personal',
            0: 'Approvato',
            ricMod: 'Richiesta di Invio Modulistica',
            confirmRicModulo: 'Sei Sicuro di voler inviare la richiesta?',
            confirmVarAnag: 'Dichiaro di avvalermi della facoltà stabilita dagli artt. 46 e 47 del DPR 445/2000 e s.m.i. consapevole delle responsabilità penali (artt. 75 e 76 DPR 445/2000) cui va incontro in caso di dichiarazione mendace o falsa. Il sottoscritto ai sensi dell\'art. 13 della legge 196/2003 dichiara inoltre di essere informato e di prestare il proprio consenso al trattamento, la comunicazione, la diffusione e la conservazione dei dati personali forniti. I dati personali che Ella ci fornisce saranno utilizzati per porre in essere tutti gli adempimenti amministrativi necessari per fornirle il servizio che Ella ci ha richiesto e per ricordarle scadenze connesse ai servizi richiesti ed a servizi correlati attraverso l\'invio di specifica informativa. Il trattamento sarà effettuato con strumenti cartacei ed informatici. Sei sicuro di voler procedere?'
          },
          btn: {
            modifica: 'Modifica',
            salva: 'Salva',
            confirm: 'Confrma',
            abort: 'Annulla'
          }
        }
      },
      fr_FR: {},
      es_ES: {
        sportello: {
          label: {
            title: 'Ventanilla digital',
            datiPers: 'Datos personales',
            varAnag: 'Variaciones Parientes',
            datiAnag: 'Visualiza datos personales',
            moduli: 'Petición de datos personales',
            residenza: 'Residencia',
            domicilio: 'Domicilio',
            statoCiv: 'Estado Civil',
            tel1: 'Teléfono 1',
            tel2: 'Teléfono 2',
            place: 'Localidad',
            address: 'Dirección',
            codPrv: 'Cod. Provincia',
            codMun: 'Cod. Municipio',
            CAP: 'Codico Postal',
            accordion1: 'Datos anagráficas',
            accordion2: 'Parientes',
            accordion3: 'Datos retributivos',
            accordion4: 'Vacaciones',
            numFigli: 'Número de hijos a cargo',
            parente: 'Pariente',
            nomeCompleto: 'Nombre y apellidos',
            nome: 'Nombre',
            cognome: 'Apellidos',
            cognome2: 'Segundo Apellidos',
            dataNascita: 'Fecha Nacimiento',
            cFisc: 'N.I.F',
            invalidita: 'Invalidez',
            aCarico: 'A su cargo',
            sesso: 'Sexo',
            no: 'NO',
            anticipo: 'Anticipo a cuenta',
            amortPrest: 'Amortizacion Prestamos',
            anticMese: 'Anticipo mes',
            anticExtra: 'Anticipo pagas extras',
            totMaturati: 'Total devengo',
            totDevengoPrec: 'Total devengo año anterior',
            totDevengoAtt: 'Total devengo año actual',
            hWorked: 'Hora normales trabajadas año actual',
            oreLav: 'Hora normales trabajadas año actual',
            reddito: 'IRPF/Cotizacion S. Social (año actual)',
            IRPFA: 'IRPF A',
            IRPFF: 'IRPF F',
            cotTrab: 'Cotizacion trabajador',
            cotEmpr: 'Cotizacion empresa',
            euro: '€',
            hours: 'h',
            day: 'd',
            annoPrec: 'año anterior',
            annoAtt: 'año actual',
            V: 'HOMBRE',
            M: 'MUYESR',
            moduli: 'lista de módulos',
            maturato: 'Maturado',
            prese: 'Tomado',
            residuo: 'Residuo'
          },
          msg: {
            copiaTitle: 'Copia datos',
            copia: '¿Está seguro de copiar los datos del domicilio?',
            1: 'Dato en elaboracion de la ificina del personal',
            0: 'Aprobados',
            confirmRicModulo: '¿Está seguro de enviar la solicitud?'
          },
          btn: {
            modifica: 'modificación',
            salva: 'Guardar',
            confirm: 'Confirmación',
            abort: 'No'
          }
        }
      },
      de_DE: {
        sportello: {
          title: 'Ventanilla digital'
        }
      },
      en_GB: {
        sportello: {}
      }
    }
  },
  data() {
    return {
      loading_varanag: false,
      loading_statociv: false,
      tabActive: '-1',
      accordionActive: '1',
      tbl_statoCiv: [],
      tbl_comuni: [],
      tbl_province: [],
      switchModifica: false,
      datiPersVar: {
        co1ra: '',
        co2dt: '',
        co3dp: '',
        codFiscCon: '',
        codStatoCiv: '',
        dataCambioRes: '',
        domCap: '',
        domCom: '',
        domDesCom: '',
        domDesProv: '',
        domDesReg: '',
        domIn: '',
        domNum: '',
        domProv: '',
        domReg: '',
        inAttesa: '',
        pref1: '',
        pref2: '',
        resCap: '',
        resCom: '',
        resDesCom: '',
        resDesProv: '',
        resDesReg: '',
        resIn: '',
        resNum: '',
        resProv: '',
        resReg: '',
        statoCiv: '',
        tel1: '',
        tel2: ''
      },
      loading_tfr: false,
      tfr: {},
      loading_fide: false,
      fide: [],
      loading_prevint: false,
      prevint: {},
      loading_assfam: false,
      assfam: {},
      loading_detfis: false,
      detfis: {},
      detfis_list: [],
      loading_congedi: false,
      congedi: [],
      tbl_sesso: [
        { codice: 'V' }, { codice: 'M' }
      ],
      moduli: [],
      modulo: '',
      loading_moduli: false
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (data, tipo) {
      switch (tipo) {
        case 'AAAAMM':
          if (data !== undefined && data !== "000000" && data.length === 6) {
            return this.$i18n.t('el.datepicker.month' + data.substring(4, 6)) + ' ' + data.substring(0, 4)
          } else {
            return ''
          }
        case 'GGMMAAAA':
          if (data !== undefined && data !== "00000000" && data.length === 8) {
            return data.substr(6, 2) + '/' + data.substr(4, 2) + '/' + data.substr(0, 4)
          } else {
            return ''
          }
        default:
          return ''
      }
    }
  },
  beforeMount: function () {
    //this.loading = true
    this.tabActive = 0
    this.loadStatoCiv()
    this.loadVarAnag()
    this.loadProvince()
    /*this.loadTipoFam()
    this.loadTipoCar()
    this.loadTipoInv()
    this.loadVarAnag()*/
  },
  mounted: function () {
  },
  methods: {
    handleClick: function (tab, event) {
      if (tab.index === '0') {
        this.loadVarAnag()
      } else if (tab.index === '1') {
        this.load_tfr()
        this.load_fide()
        this.load_prevint()
        this.load_assfam()
        this.load_detfis()
        this.load_congedi()
      } else if (tab.index === '2') {
        this.load_moduli()
      }
    },
    formatEuro: function (value) {
      return (value === '' ? '0,00' : value) + ' ' + this.$t('sportello.label.euro')
    },
    formatDate: function (value) {
      return (value === '' ? '0,00' : value) + ' ' + this.$t('sportello.label.day')
    },
    loadProvince: function () {
      this.$set(this, 'tbl_province', [])
      this.$http.get('dipendente/' + this.$store.state.country + '/province')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_province = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          // this.loading = false
        })
    },
    searchComuni: function (query) {
      if (query !== undefined && query !== '') {
        this.loadComuni(query)
      }
    },
    changeComune: function (value, tipo) {

      this.$set(this.datiPersVar, tipo + 'DesProv', this.tbl_province.find(x => x.codProv === value.prov).prov)
      //this.$set(this, 'domDesReg', )
      this.$set(this.datiPersVar, tipo + 'Prov', this.tbl_province.find(x => x.codProv === value.prov).codProv)
      //this.$set(this, 'domReg', )
      this.$set(this.datiPersVar, tipo + 'Cap', value.cap)
      this.$set(this.datiPersVar, tipo + 'Com', value.codice)
      this.$set(this.datiPersVar, tipo + 'DesCom', value.comune)

      this.getRegione(value.prov, tipo)
    },
    loadComuni: function (query) {
      var obj = {
        params: {
          filtro: query.toUpperCase(),
          action: 'BEGIN',
          pagFrom: 1,
          pagFor: 100
        }
      }
      this.$http.get('dipendente/' + this.$store.state.country + '/comuni', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_comuni = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          // this.loading = false
        })
    },
    getRegione: function (pr, tipo) {
      this.$set(this.datiPersVar, tipo + 'DesReg', '')
      this.$set(this.datiPersVar, tipo + 'Reg', '')
      var obj = {
        params: {
          codProv: pr
        }
      }
      this.$http.get('dipendente/' + this.$store.state.country + '/regione', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this.datiPersVar, tipo + 'DesReg', response.body.data.reg)
            this.$set(this.datiPersVar, tipo + 'Reg', response.body.data.codReg)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    loadStatoCiv: function () {
      this.$set(this, 'loading_statociv', true)
      this.$http.get('dipendente/' + this.$store.state.country + '/listStatCiv')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_statoCiv = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.$set(this, 'loading_statociv', false)
        }, response => {
          this.$set(this, 'loading_varanag', false)
        })
    },
    loadVarAnag: function () {
      this.$set(this, 'loading_varanag', true)
      this.loading = true
      this.$http.get('sportello/' + this.$store.state.country + '/varanag')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'datiPersVar', response.body.data)
            if (this.datiPersVar.dataCambioRes === '00000000') {
              this.$set(this.datiPersVar, 'dataCambioRes', '')
            }
            if (response.body.msg !== undefined) {
              this.datiPersVar.inAttesaMsg = response.body.msg[0].msgTxt
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.$set(this, 'loading_varanag', false)
        }, response => {
          this.$set(this, 'loading_varanag', false)
        })
    },
    confirmVarAnag: function () {
      let _this = this
      this.$confirm(this.$i18n.t('sportello.msg.confirmVarAnag'), this.$i18n.t('sportello.datiPers'), {
        confirmButtonText: this.$i18n.t('sportello.btn.confirm'),
        cancelButtonText: this.$i18n.t('sportello.btn.abort'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.saveVarAnag()
          }
        }
      })
    },
    saveVarAnag: function () {
      this.$set(this, 'loading_varanag', true)
      let obj = JSON.parse(JSON.stringify(this.datiPersVar))
      delete obj['co1ra']
      delete obj['co2dt']
      delete obj['co3dp']
      delete obj['inAttesa']
      delete obj['statoCiv']
      delete obj['resDesCom']
      delete obj['resDesProv']
      delete obj['resDesReg']
      delete obj['domDesCom']
      delete obj['domDesProv']
      delete obj['domDesReg']
      obj['domPro'] = obj.domProv
      delete obj['domProv']
      obj['resPro'] = obj.resProv
      delete obj['resProv']
      obj['domReg'] = ''
      // obj ['tel1'] = obj.tel1 === '' ? '***' : obj.tel1
      // obj ['tel2'] = obj.tel2 === '' ? '***' : obj.tel2
      this.$http.post('sportello/' + this.$store.state.country + '/varanag', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.$set(this, 'loading_varanag', false)
            this.$set(this, 'switchModifica', false)
            this.loadVarAnag()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'loading_varanag', false)
          }
        }, response => {
          this.$set(this, 'loading_varanag', false)
        })
    },
    load_tfr: function () {
      this.$set(this, 'loading_tfr', true)
      this.$set(this, 'tfr', {})
      this.$http.get('sportello/' + this.$store.state.country + '/tfr').then(response => {
        if (response.body.rc === 0) {
          this.$set(this, 'tfr', response.body.data)
        } else {
          /*this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })*/
        }
        this.$set(this, 'loading_tfr', false)
      }, response => {
        this.$set(this, 'loading_tfr', false)
      })
    },
    load_fide: function () {
      this.$set(this, 'loading_fide', true)
      this.$http.get('sportello/' + this.$store.state.country + '/fide').then(response => {
        if (response.body.rc === 0) {
          this.$set(this, 'fide', response.body.data)
        } else {
          /*this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })*/
        }
        this.$set(this, 'loading_fide', false)
      }, response => {
        this.$set(this, 'loading_fide', false)
      })
    },
    load_prevint: function () {
      this.$set(this, 'loading_prevint', true)
      this.$set(this, 'prevint', {})
      this.$http.get('sportello/' + this.$store.state.country + '/prevint').then(response => {
        if (response.body.rc === 0) {
          this.$set(this, 'prevint', response.body.data)
        } else {
          /*this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })*/
        }
        this.$set(this, 'loading_prevint', false)
      }, response => {
        this.$set(this, 'loading_prevint', false)
      })
    },
    load_assfam: function () {
      this.$set(this, 'loading_assfam', true)
      this.$http.get('sportello/' + this.$store.state.country + '/assfam').then(response => {
        if (response.body.rc === 0) {
          this.$set(this, 'assfam', response.body.attrib)
        } else {
          /*this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })*/
        }
        this.$set(this, 'loading_assfam', false)
      }, response => {
        this.$set(this, 'loading_assfam', false)
      })
    },
    load_detfis: function () {
      this.$set(this, 'loading_detfis', true)
      this.$set(this, 'detfis', {})
      this.$set(this, 'detfis_list', [])
      this.$http.get('sportello/' + this.$store.state.country + '/detfis').then(response => {
        if (response.body.rc === 0) {
          this.$set(this, 'detfis', response.body.attrib)
          this.$set(this, 'detfis_list', response.body.data)
        } else {
          /*this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })*/
        }
        this.$set(this, 'loading_detfis', false)
      }, response => {
        this.$set(this, 'loading_detfis', false)
      })
    },
    load_congedi: function () {
      this.$set(this, 'loading_congedi', true)
      this.$set(this, 'congedi', [])
      this.$http.get('sportello/' + this.$store.state.country + '/congedi').then(response => {
        if (response.body.rc === 0) {
          this.$set(this, 'congedi', response.body.data)
        } else {
          /*this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })*/
        }
        this.$set(this, 'loading_congedi', false)
      }, response => {
        this.$set(this, 'loading_congedi', false)
      })
    },
    copiaResidenza: function () {
      let _this = this
      this.$confirm(this.$i18n.t('sportello.msg.copiaTitle'), this.$i18n.t('sportello.msg.copia'), {
        confirmButtonText: this.$i18n.t('sportello.btn.confirm'),
        cancelButtonText: this.$i18n.t('sportello.btn.abort'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.$set(_this.datiPersVar, 'domCap', _this.datiPersVar.resCap)
            _this.$set(_this.datiPersVar, 'domCom', _this.datiPersVar.resCom)
            _this.$set(_this.datiPersVar, 'domDesCom', _this.datiPersVar.resDesCom)
            _this.$set(_this.datiPersVar, 'domDesProv', _this.datiPersVar.resDesProv)
            _this.$set(_this.datiPersVar, 'domDesReg', _this.datiPersVar.resDesReg)
            _this.$set(_this.datiPersVar, 'domIn', _this.datiPersVar.resIn)
            _this.$set(_this.datiPersVar, 'domNum', _this.datiPersVar.resNum)
            _this.$set(_this.datiPersVar, 'domProv', _this.datiPersVar.resProv)
            _this.$set(_this.datiPersVar, 'domReg', _this.datiPersVar.resReg)
          }
        }
      })
    },
    load_moduli: function () {
      this.$set(this, 'loading_moduli', true)
      this.$set(this, 'moduli', [])
      this.$http.get('sportello/' + this.$store.state.country + '/moduli')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'moduli', response.body.data)
            this.tbl_province = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.$set(this, 'loading_moduli', false)
        }, response => {
          this.$set(this, 'loading_moduli', false)
        })
    },
    ricModulo: function () {
      let _this = this
      let obj = {
        tipo: this.modulo
      }
      this.loading = true
      this.$confirm(this.$i18n.t('sportello.msg.confirmRicModulo'), this.$i18n.t('sportello.ricMod.'), {
        confirmButtonText: this.$i18n.t('sportello.btn.confirm'),
        cancelButtonText: this.$i18n.t('sportello.btn.abort'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.$http.post('sportello/' + _this.$store.state.country + '/modulo', obj)
              .then(response => {
                if (response.body.rc === 0) {
                  _this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'success',
                    duration: process.env.duration
                  })
                } else {
                  _this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
                _this.loading = false
              })
          }
        }
      })
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-approved'
        case '1':
          return 'status-send'
        default:
          return ''
      }
    },
    getDate: function (tipo, data) {
      switch (tipo) {
        case 'AAAAMM':
          if (data !== undefined && data !== "000000" && data.length === 6) {
            return this.$i18n.t('el.datepicker.month' + parseInt(data.substring(4, 6))) + ' ' + data.substring(0, 4)
          } else {
            return ''
          }
        case 'AAAAMMGG':
          if (data !== undefined && data !== "000000" && data.length === 8) {
            return data.substr(6, 2) + '/' + data.substr(4, 2) + '/' + data.substr(0, 4)
          } else {
            return ''
          }
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.sportello {
  .header-tab {
    height: 80px;
    text-align: center;

    .return {
      margin-top: 10px;
      line-height: 55px;
      height: 45px;
      float: left;
      .set-font(@color: @greenRiva, @weight: bold);

      .fa-icon {
        float: left;
        cursor: pointer;
      }
    }

    .my-label {
      display: block;
      line-height: 55px;
      height: 45px;
      .set-font(@color: @oroRiva, @size: 22px, @weight: bold, @family: 'os-semibolditalic');
      letter-spacing: 2px;
    }

    .my-label-subtitle {
      display: block;
      .set-font(@size: 13px, @weight: normal, @family: 'os-lightitalic');
      height: 25px;
    }

  }

  .el-tabs__content {
    .el-collapse {
      border: none;
    }

    .el-collapse-item__header {
      margin-bottom: 10px;
      //height: 20px;
      //border-bottom: 1px solid #dedede;
      color: @oroRiva;
      font-weight: bold;
      text-align: left;
      //margin-right: 15px;
      text-transform: uppercase;
      letter-spacing: 2px;

      &.is-active {
        border-bottom: 1px solid #dedede;
      }
    }

    .action {
      float: right;
      text-align: right;
      margin-bottom: 10px;
    }
  }

  .tab-sportello {
    height: auto;

    .colonna-md {
      margin-left: 1px;
    }

    .colonna {
      height: 100%;
      margin-top: 20px;

      .blocco {
        padding-bottom: 30px;

        .elemento {
          height: auto;

          .my-area-panel {
            margin-bottom: 10px;
            height: 20px;
            //border-bottom: 1px solid #dedede;
            color: #999;
            font-weight: bold;
            text-align: left;
            //margin-right: 15px;
            text-transform: uppercase;
            letter-spacing: 2px;
          }

          .my-area {
            margin-bottom: 10px;
            height: 20px;
            border-bottom: 1px solid #dedede;
            color: @oroRiva;
            font-weight: bold;
            text-align: left;
            //margin-right: 15px;
            text-transform: uppercase;
            letter-spacing: 2px;
          }

          .sportello-label {
            .set-font(@color: @greenRiva; @size: 13px);
            display: inline;
            text-align: right;
            line-height: 16px;
            height: 22px;
            padding-top: 5px;
            padding-bottom: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .sportello-value {
            .set-font(@color: #454848; @size: 12px);
            display: inline;
            text-align: left;
            word-wrap: break-word;
            white-space: normal;
            line-height: 16px;
            min-height: 26px;
            height: 100%;
            border-left: 1px solid @oroRiva;
            padding-top: 5px;
            padding-bottom: 5px;

            .icona {
              color: #54e912;
            }

            .el-input {
              color: @grayMedium;

              &.is-disabled {
                .el-input__inner {
                  border: none;
                }
              }

              .el-input__inner {
                border: none;
                border-bottom: 1px solid #dcdfe6;
                border-radius: 0px;
                height: 22px;
                padding-left: 0px;
                line-height: 0px;
                .set-font(@size: 12px);
                color: @grayMedium;
              }

              .el-input__suffix {
                .el-input__icon {
                  line-height: 22px;
                  width: 17px;
                }
              }
            }

            .el-date-editor--time {
              width: 150px !important;
            }

            .el-select {
              height: 22px;
              width: 100%;

              .el-input {
                height: 22px;

                .el-input__inner {
                  border: none;
                  border-bottom: 1px solid #dcdfe6;
                  border-radius: 0px;
                  height: 22px !important;
                  padding-left: 0px;
                  .set-font(@size: 12px);
                  color: @grayMedium;

                }
              }
            }

            .el-date-editor {
              width: 100%;

              .el-input__inner {
                padding-left: 30px !important;
              }

              .el-input__prefix {
                left: 0px;

                .el-input__icon {
                  line-height: 22px;
                  width: 17px;
                }
              }

              .el-input__suffix {
                .el-input__icon {
                  line-height: 22px;
                  width: 17px;
                }
              }

              &.time {
                width: 100px;
              }
            }
          }

          .my-radio {
            .el-radio__label {
              padding-left: 15px;
              .set-font(@size: 12px);
              color: #454848;
              display: inline;
              text-align: left;
              word-wrap: break-word;
              white-space: normal;
              line-height: 16px;
              min-height: 26px;
              height: 100%;
              padding-top: 5px;
              padding-bottom: 5px;
            }
          }
        }
      }

      .secondo-blocco {
        margin-top: 20px;
      }
    }

    &.inAttesa {
      text-align: center;
      background-color: #e8ddc1;
      height: 40px;
      line-height: 40px;
      font-weight: bold;
    }
  }

  .el-tabs {
    margin-top: 40px;

    .el-tabs__header {
      border-bottom: 1px solid #ccc;
      margin-bottom: 0px;

      .el-tabs__nav-wrap {
        margin-top: 0px;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav {
        border: 0px;
        height: 33px;

        .el-tabs__item {
          text-align: center;
          padding-left: 0px;
          padding-right: 0px;
          border: 0px;
          height: 30px;
          line-height: 30px;
          .set-font(@color: #999);
          letter-spacing: 1px;

          &.is-active {
            .set-font(@weight: bold);

            // background-color: #efe8da;
            .barra {
              background-image: linear-gradient(to right, @oroRiva, @greenRiva);
              height: 3px;
            }
          }
        }

        .el-tabs__item:hover {
          color: @greenRiva;
        }
      }
    }
  }
}

.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.inoltraBtn {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SportelloDigitale/SportelloIT.vue